export const customStyles = {
	content: {
		top: '10%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translateX(-50%)',
		backgroundColor: '#1e2328',
		padding: '30px',
	},


	overlay: {
		overflow: 'auto',
		backgroundColor: 'rgba(1, 1, 1, 0.75)',
		zIndex: '99',
	},
};